import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightCondensed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.62793 4.3486C9.98755 4.14318 10.4459 4.2683 10.6514 4.6279L14.6514 11.6279C14.783 11.8584 14.783 12.1415 14.6514 12.372L10.6514 19.372C10.4459 19.7316 9.98755 19.8568 9.62793 19.6513C9.26833 19.4458 9.14321 18.9875 9.34863 18.6279L13.1357 12L9.34863 5.37204C9.14321 5.01242 9.26833 4.55409 9.62793 4.3486Z",
		fill: "currentColor"
	})
});
export default SvgChevronRightCondensed;
